<template>
  <section>
    <el-card shadow="never" size="small">
      <div slot="header" class="clearfix">
        <span>更新昵称</span>
      </div>
      <el-form
        ref="editNameForm"
        :model="editNameForm"
        label-width="80px"
        @submit.prevent="onSubmit"
        size="small"
        :rules="NameFormRules"
        style="margin:20px;width:60%;min-width:600px;"
      >
        <el-form-item label="我的昵称" prop="NickName">
          <el-input v-model="editNameForm.NickName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmitName" type="primary" :loading="editNameLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <br />
    <el-card shadow="never" size="small">
      <div slot="header" class="clearfix">
        <span>修改密码</span>
      </div>
      <el-form
        ref="editForm"
        :model="editForm"
        label-width="80px"
        size="small"
        @submit.prevent="onSubmit"
        style="margin:20px;width:60%;min-width:600px;"
        :rules="FormRules"
      >
        <el-form-item label="旧密码" prop="LoginPwdOld">
          <el-input v-model="editForm.LoginPwdOld" type="text"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="LoginPwdNew">
          <el-input v-model="editForm.LoginPwdNew" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="LoginPwdNewQr">
          <el-input v-model="editForm.LoginPwdNewQr" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit" type="primary" :loading="editLoading">确认修改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </section>
</template>
<script>
import util from "util/date";
import { editUserInfo } from "@/api/api";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.editForm.LoginPwdNew) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      editNameForm: {
        Model: 1,
        NickName: ""
      },
      editForm: {
        Model: 2,
        LoginPwdOld: "",
        LoginPwdNew: "",
        LoginPwdNewQr: ""
      },
      NameFormRules: {
        NickName: [{ required: true, message: "请输入原密码" }]
      },
      FormRules: {
        LoginPwdOld: [{ required: true, message: "请输入原密码" }],
        LoginPwdNew: [{ required: true, message: "请输入新密码" }],
        LoginPwdNewQr: [{ validator: validatePass }]
      },
      editNameLoading: false,
      editLoading: false
    };
  },
  methods: {
    onSubmitName() {
      this.$refs.editNameForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editNameLoading = true;
              let para = Object.assign({}, this.editNameForm);

              editUserInfo(para).then(res => {
                
                if (util.isEmt.format(res)) {
                  this.editNameLoading = false;
                  return;
                }
                this.editNameLoading = false;
                if (res.data.success) {
                  window.localStorage.user = JSON.stringify(res.data.response);
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    onSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);

              editUserInfo(para).then(res => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                this.editLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    }
  },
  mounted() {
    var user = JSON.parse(window.localStorage.user);
    this.editNameForm.NickName = user ? user.NickName : "";
  }
};
</script>
